import { ApolloClient } from 'apollo-client'
import { ApolloLink } from 'apollo-link'
import { HttpLink } from 'apollo-link-http'
import {
  InMemoryCache,
  IntrospectionFragmentMatcher
} from 'apollo-cache-inmemory'
import { setContext } from 'apollo-link-context'
import { CachePersistor } from 'apollo-cache-persist'

import { apolloStorage, schemaStorage } from './storage'

import introspectionQueryResultData from './fragmentTypes.json'

const API_ENDPOINT = `${process.env.REACT_APP_API_URI}/graphql`
const SCHEMA_VERSION = '3'
const SCHEMA_VERSION_KEY = 'apollo-schema-version'

const setupLink = () => {
  const httpLink = new HttpLink({ uri: API_ENDPOINT })

  const authTokenLink = setContext((_, { headers }) => {
    const token = localStorage.getItem('token')
    return {
      headers: {
        ...headers,
        authorization: token ? `Bearer ${token}` : ''
      }
    }
  })

  return ApolloLink.from([authTokenLink, httpLink])
}

const setupCache = async () => {
  const fragmentMatcher = new IntrospectionFragmentMatcher({
    introspectionQueryResultData
  })

  const cacheOptions = {
    dataIdFromObject: ({ __typename, slug }) =>
      slug ? `${__typename}:${slug}` : null,
    cacheRedirects: {
      Query: {
        customerBenefit: (_, { where: { slug } }, { getCacheKey }) =>
          getCacheKey({
            __typename: 'CustomerBenefit',
            slug
          }),
        topic: (_, { where: { slug } }, { getCacheKey }) =>
          getCacheKey({
            __typename: 'Topic',
            slug
          }),

        component: (_, { where: { slug } }, { getCacheKey }) =>
          getCacheKey({
            __typename: 'Component',
            slug
          }),

        vehicle: (_, { where: { slug } }, { getCacheKey }) =>
          getCacheKey({
            __typename: 'Vehicle',
            slug
          }),

        topicCluster: (_, { where: { slug } }, { getCacheKey }) =>
          getCacheKey({
            __typename: 'TopicCluster',
            slug
          })
      }
    },
    fragmentMatcher
  }

  const cache = new InMemoryCache(cacheOptions)

  if (process.env.REACT_APP_ENABLE_OFFLINE === 'true') {
    const persistor = new CachePersistor({
      cache,
      storage: apolloStorage,
      maxSize: false,
      debug: false
    })

    const currentSchemaVersion = await schemaStorage.getItem(SCHEMA_VERSION_KEY)

    if (currentSchemaVersion === SCHEMA_VERSION) {
      await persistor.restore()
    } else {
      await persistor.purge()
      await schemaStorage.setItem(SCHEMA_VERSION_KEY, SCHEMA_VERSION)
    }
  }

  return cache
}

const setupApolloClient = async () => {
  const link = setupLink()
  const cache = await setupCache()

  return new ApolloClient({
    link,
    cache
  })
}

export default setupApolloClient



// WEBPACK FOOTER //
// ./src/apolloClient.js